import { useEffect, useState } from "react";
import Web3 from "web3";

export const useCurrentBlock = () => {
  const [currentBlock, setCurrentBlock] = useState<number | null>(0);

  useEffect(() => {
    const fetchCurrentBlock = async () => {
      try {
        if (!window.ethereum) {
          console.error(
            "Ethereum provider not found. Please install MetaMask."
          );
          // setCurrentBlock(null);
          return;
        }

        await window.ethereum.request({ method: "eth_requestAccounts" });

        const web3 = new Web3(window.ethereum);
        const blockNumber = await web3.eth.getBlockNumber();
        setCurrentBlock(Number(blockNumber));
      } catch (error) {
        console.error("Error fetching current block:", error);
        setCurrentBlock(null);
      }
    };

    fetchCurrentBlock();
    const interval = setInterval(fetchCurrentBlock, 10000);
    return () => clearInterval(interval);
  }, []);

  return currentBlock;
};
